import React, { useEffect, useRef, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Repère doré (divIcon → pas de dépendance aux images marqueurs Leaflet qui 404 sous webpack).
const PIN = L.divIcon({
  html: '<div style="width:18px;height:18px;border-radius:50% 50% 50% 0;background:#C19A6B;border:2px solid #fff;transform:rotate(-45deg);box-shadow:0 2px 8px rgba(0,0,0,.45)"></div>',
  className: "", iconSize: [18, 18], iconAnchor: [9, 18],
});

// Carte OpenStreetMap fiable (aucune clé API requise), thème sombre par filtre CSS.
// Accepte des coordonnées directes OU une requête texte (géocodée via Nominatim).
export default function LeafletMiniMap({ lat, lng, query = "", zoom = 13, label = "", className = "", dark = true }) {
  const ref = useRef(null);
  const inst = useRef(null);
  const [coords, setCoords] = useState(
    lat != null && lng != null && !Number.isNaN(Number(lat)) ? [Number(lat), Number(lng)] : null
  );

  useEffect(() => {
    if (coords || !query) return;
    let active = true;
    const q = encodeURIComponent(`${query}, France`);
    fetch(`https://nominatim.openstreetmap.org/search?q=${q}&format=json&limit=1`, { headers: { Accept: "application/json" } })
      .then((r) => (r.ok ? r.json() : []))
      .then((d) => { if (active && d && d[0]) setCoords([parseFloat(d[0].lat), parseFloat(d[0].lon)]); })
      .catch(() => {});
    return () => { active = false; };
  }, [query, coords]);

  useEffect(() => {
    if (!coords || !ref.current || inst.current) return;
    const map = L.map(ref.current, { scrollWheelZoom: false }).setView(coords, zoom);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; OpenStreetMap', subdomains: "abc", maxZoom: 19,
    }).addTo(map);
    const mk = L.marker(coords, { icon: PIN }).addTo(map);
    if (label) mk.bindPopup(`<b>${label}</b>`);
    inst.current = map;
    const t = setTimeout(() => map.invalidateSize(), 200);
    return () => { clearTimeout(t); map.remove(); inst.current = null; };
  }, [coords, zoom, label]);

  return <div ref={ref} className={`${className} ${dark ? "leaflet-dark" : ""}`} />;
}
